<template>
    <MarkerContainer isAddButton @click:marker="addDeployment" />
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import Planbord from '@/components/Planbord.vue';
    import MarkerContainer from '@/components/Planbord/MarkerContainer.vue';

    @Component({
        components: {
            MarkerContainer,
        },
    })
    export default class DeploymentAddButton extends Vue {
        @Prop({type: Number, required: true}) public horizontalPosition!: number;
        @Prop({type: Number, required: true}) public verticalPosition!: number;
        @Prop({type: Number, required: true}) public deploymentIndex!: number;

        public addDeployment(): void {
            /** @see Planbord.setActiveCell() */
            // @ts-expect-error TS2339
            Planbord.__vfdConstructor.setActiveCell(this.horizontalPosition, this.verticalPosition, true, true, this.deploymentIndex);
        }
    }
</script>
